<div fxLayout="column">
    <mat-card>
        <mat-card-header>
            <mat-card-title><h3 class="block-title">{{ 'number_location.content.primary_addr'|translate }}</h3></mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div *ngIf="dataSourcePrimary && dataSourcePrimary.data && dataSourcePrimary.data.length;else LinkDefinePrimaryAddr">
                <ng-container *ngTemplateOutlet="TableNumberLocation; context: {type: 'primary'}"></ng-container>
            </div>

            <ng-template #LinkDefinePrimaryAddr>
                <a class="flex-link ml-2" (click)="createNumberLocation(true)">{{ 'number_location.action.add_primary_addr'|translate }}</a>
            </ng-template>
        </mat-card-content>
    </mat-card>

    <mat-card class="mt-1">
        <mat-card-header fxLayout="row" fxLayoutAlign="start center">
            <mat-card-title>
                <h3 class="block-title">{{ 'number_location.content.secondary_addr'|translate }}</h3>
            </mat-card-title>
            <a class="flex-link title-link" (click)="createNumberLocation(false)">{{ 'number_location.action.add_secondary_addr'|translate }}</a>
        </mat-card-header>

        <mat-card-content *ngIf="dataSourceSecondary && dataSourceSecondary.data && dataSourceSecondary.data.length">
            <ng-container *ngTemplateOutlet="TableNumberLocation; context: {type: 'secondary'}"></ng-container>
        </mat-card-content>
    </mat-card>
</div>


<ng-template #TableNumberLocation let-type="type">
    <flex-table #FlexTable [dataSource]="type === 'primary' ? dataSourcePrimary: dataSourceSecondary" [tableConfig]="tableConfig" [columnTemplates]="{
        address: tplAddress,
        action: tplAction
    }">
        
        <ng-template #tplAddress let-item="row">
            {{ item.address }}
        </ng-template>

        <ng-template #tplAction let-item="row">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div>
                    <button mat-icon-button [title]="'public.edit'|translate" (click)="editNumberLocation(item)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
                
                <div>
                    <button mat-icon-button [title]="'public.delete'|translate" class="mat-text-warn"
                        (click)="deleteNumberLocation(item)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <div *ngIf="type !== 'primary'">
                    
                    <button mat-icon-button [title]="'number_location.action.switch_primary'|translate"
                        (click)="makeNumberLocationAsPrimary(item)">
                        <mat-icon>upgrade</mat-icon>
                    </button>
                </div>
            </div>
        </ng-template>
    </flex-table>
</ng-template>
